export const isInternalBool = (location: string) => {
    if (location === "Internal") return true;
    if (location === "External") return false;

    return undefined;
};